import React from "react";
import { DiJava, DiDotnet } from "react-icons/di";
import {
    SiNodedotjs as SiNode,
    SiFlutter,
    SiPhp,
    SiPython,
} from "react-icons/si";
import { PiTestTubeFill, PiRocketDuotone } from "react-icons/pi";

import SectionHeading from "../common/SectionHeading";
import SimpleLinedCard from "../common/SimpleLinedCard";

const content = [
    {
        title: "PHP Stacks",
        content:
            "A comprehensive and proven cloud platform infrastructure for managing and scaling web and mobile apps.",
        icon: <SiPhp size="120" />,
    },
    {
        title: "NodeJs Stacks",
        content:
            "A comprehensive and proven cloud platform infrastructure for managing and scaling web and mobile apps.",
        icon: <SiNode size="120" />,
    },
    {
        title: "Flutter Stacks",
        content:
            "A comprehensive and proven cloud platform infrastructure for managing and scaling web and mobile apps.",
        icon: <SiFlutter size="120" />,
    },
    {
        title: "Python Stacks",
        content:
            "A comprehensive and proven cloud platform infrastructure for managing and scaling web and mobile apps.",
        icon: <SiPython size="120" />,
    },
    {
        title: "Java Stacks",
        content:
            "A comprehensive and proven cloud platform infrastructure for managing and scaling web and mobile apps.",
        icon: <DiJava size="120" />,
    },
    {
        title: ".NET Stacks",
        content:
            "A comprehensive and proven cloud platform infrastructure for managing and scaling web and mobile apps.",
        icon: <DiDotnet size="120" />,
    },
    {
        title: "Testing",
        content:
            "A comprehensive and proven cloud platform infrastructure for managing and scaling web and mobile apps.",
        icon: <PiTestTubeFill size="120" />,
    },
    {
        title: "Deployment",
        content:
            "A comprehensive and proven cloud platform infrastructure for managing and scaling web and mobile apps.",
        icon: <PiRocketDuotone size="120" />,
    },
];

const OurTechStack = () => {
    return (
        <section className="font-[Montserrat]">
            <div className="bg-background">
                <div className="pt-10 pb-7">
                    <div className="container mx-auto md:px-14 px-8">
                        <div className="pb-5 md:pb-10">
                            <SectionHeading>
                                Revealing Our Tech Stack!
                            </SectionHeading>

                            <div className="text-center font-semibold text-2xl p-2">
                                We Craft Delightful App Development Solutions
                                using Trending Technologies.
                            </div>
                        </div>

                        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 md:gap-5 text-secondaryText">
                            {content.map(({ title, content, icon }, index) => (
                                <SimpleLinedCard
                                    index={index}
                                    icon={icon}
                                    title={title}
                                    content={content}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurTechStack;
